import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {  ContentRoute } from "../_metronic/layout";
// import { LayoutSplashScreen } from "../_metronic/layout";
import BuilderPage from "./pages/BuilderPage";
import MyPage from "./pages/MyPage";
import DashboardPage from "./pages/DashboardPage";
import ManualPage from "./pages/ManualPage";
import ChangePassword from "./pages/ChangePassword";

const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

/* 引入自定義modules */
const OrderManagement = lazy(() =>
  import("./modules/OrderManagement/OrderManagementRouterPage")
);
const CustomerMessage = lazy(() =>
  import("./modules/CustomerMessage/CustomerMessageRouterPage")
);
const NotificationRecord = lazy(() =>
  import("./modules/NotificationRecord/NotificationRecordRouterPage")
);
const FreightMaintain = lazy(() =>
  import("./modules/FreightMaintain/FreightMaintainRouterPage")
);

const Registration = lazy(() =>
  import("./modules/Auth/pages/Registration")
);



export default function BasePage() {
  // 抓取store內的user資料
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  useEffect(() => {
    return () => {
    };
  }, [user]);


  // console.log('already into BasePage');
  return (
    // <Suspense fallback={<LayoutSplashScreen />}>
    <Suspense fallback={null}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        <ContentRoute path="/manual" component={ManualPage} /> 
        <ContentRoute path="/changePassword" component={ChangePassword} />
        
        {/** 自定義頁面 */}
        {/* { user.premission ===true
        ? (<ContentRoute path="/orderManagement" component={OrderManagementPage} />)
        : (<ContentRoute path="/customerMessage" component={CustomerMessagePage} /> || <ContentRoute path="/notificationRecord" component={NotificationRecordPage} />)} */}
        {/* <HocPrivateRoute path="/orderManagement" component={OrderManagementPage} />
         { user.premission
        ? <ContentRoute path="/orderNumber" component={OrderNumberPage} />
        :  <HocPrivateRoute path="/orderNumber" component={OrderNumberPage} />} */}
        {/* <ContentRoute path="/returnManagement" component={ReturnManagementPage} />
        <ContentRoute path="/customerMessage" component={CustomerMessagePage} />
        <ContentRoute path="/customerMessageInOrder" component={CustomerMessageInOrder} />
        <ContentRoute path="/notificationRecord" component={NotificationRecordPage} />
        <HocPrivateRoute path="/freightMaintain" component={FreightMaintainPage} />
        {user.premission
          ? <ContentRoute path="/addFreightMaintain" component={AddFreightMaintainPage} />
          : <HocPrivateRoute path="/addFreightMaintain" component={AddFreightMaintainPage} />}
        {user.premission
          ? <ContentRoute path="/editFreightMaintain" component={EditFreightMaintainPage} />
          : <HocPrivateRoute path="/editFreightMaintain" component={EditFreightMaintainPage} />}
        <ContentRoute path="/Profile" component={ProfilePage} /> */}
        

        {/* 自定義modules */}
        <Route path="/orderManagement" component={OrderManagement} />
        <Route path="/customerMessage" component={CustomerMessage} />
        <Route path="/notificationRecord" component={NotificationRecord} />
        <Route path="/freightMaintain" component={FreightMaintain} />
        <Route path="/Registration" component={Registration} />

        {/* 預設 */}
        <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/user-profile" component={UserProfilepage} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
